/// <amd-module name="Wit/WorkItemModel/WorkItem/Sorting" />

interface FlaggedArray<T> extends Array<T> {
    sorted: boolean;
    comparer: (a: T, b: T) => number;
}

export function copySortFlag<T>(toArray: T[], fromArray: T[]) {
    const toArr = toArray as FlaggedArray<T>;
    const fromArr = fromArray as FlaggedArray<T>;

    toArr.sorted = fromArr.sorted;
    toArr.comparer = fromArr.comparer;
}

export function flagSorted<T>(array: T[], comparer: (a: T, b: T) => number) {
    const arr = array as FlaggedArray<T>;

    arr.sorted = true;
    arr.comparer = comparer;
}

export function sortIfNotSorted<T>(array: T[], comparer: (a: T, b: T) => number): boolean {
    if (!isSorted(array, comparer)) {
        array.sort(comparer);
        flagSorted(array, comparer);

        return true;
    }

    return false;
}

export function isSorted<T>(array: T[], comparer: (a: T, b: T) => number): boolean {
    const arr = array as FlaggedArray<T>;

    return arr.sorted && arr.comparer === comparer;
}
